import type { Payment } from "@albertine/types/openapi";
import { Lib } from "albertine-shared-web";
import { convertPriceToString } from "../../../common/currency";
import type { Booking } from "../../../common/types/Booking";
import { getTotalAndRemainingAmount } from "../../../common/utils/math.util";
import Label from "../../Common/Label";

export function TotalPaymentsRequested({
    booking,
    payments,
}: {
    booking: Booking;
    payments: Payment[];
}) {
    if (!booking.priceCurrency) return null;

    const { total: totalPaidAmount, remainingAmount } = getTotalAndRemainingAmount(
        booking.price?.amount ?? 0,
        payments.map((req) => req.amount ?? 0),
    );

    return (
        <Lib.Flex.Column gap="value16">
            <Lib.Flex.Row justifyContent="space-between">
                <Label.Large.SemiBold.N10>Total paid</Label.Large.SemiBold.N10>
                <Label.Large.SemiBold.N10>
                    {convertPriceToString({
                        amount: totalPaidAmount,
                        currency: booking.priceCurrency,
                    })}
                </Label.Large.SemiBold.N10>
            </Lib.Flex.Row>

            <Lib.Flex.Row justifyContent="space-between">
                <Label.Medium.SemiBold.N10>Left to pay</Label.Medium.SemiBold.N10>
                <Label.Medium.Normal.N10>
                    {convertPriceToString({
                        amount: remainingAmount,
                        currency: booking.priceCurrency,
                    })}
                </Label.Medium.Normal.N10>
            </Lib.Flex.Row>
        </Lib.Flex.Column>
    );
}
